// ============================================
// ROLC OneROLC - Constants
// Version: 3.9.0
// ============================================

export const CONFIG = {
    API_URL: "/api/",
    TOKEN_KEY: "rolc_token",
    SESSION_ID_KEY: "rolc_session_id",
    NAME_KEY: "rolc_name",
    ROLE_KEY: "rolc_role",
    EVENTS_KEY: "rolc_events_cache",
    EVENTS_TS_KEY: "rolc_events_ts",
    SURVEYS_KEY: "rolc_surveys_cache",
    SURVEYS_TS_KEY: "rolc_surveys_ts",
    CACHE_MS: 60000,
    CACHED_SESSION_KEY: "cached_session_id",
    VERSION: "3.9.0"
};

export const IDLE_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes
export const IDLE_KEY = "rolc_last_activity";
export const DB_NAME = "rolc_queue";
export const STORE_NAME = "submissions";

